<template>
  <div class="lendio-branding" :style="appStyleProps">
    <div class="lendio-branding-text">{{ appNavPoweredByLendioText || 'Powered by' }} Lendio&#8482;</div>
    <NuxtImg v-if="appNavPoweredByLendioLogo" class="lendio-logo-mark" :src="formatImagePath(appNavPoweredByLendioLogo)" alt="" />
    <NuxtImg v-else src="/images/logomark-circle-light.svg" alt="" class="lendio-logo-mark" />
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import formatImagePath from '~/libs/image-format'

export default {
  name: 'PoweredByLendio',
  setup() {
    return { formatImagePath }
  },
  computed: {
    ...mapState(useAffiliateCustomizationStore, [
      'appStyleProps',
      'appNavPoweredByLendioText',
      'appNavPoweredByLendioLogo'
    ]),
  }
}
</script>

<style lang="scss" scoped>
$app-nav-powered-by-lendio-font-color: var(--app-nav-powered-by-lendio-font-color);
$app-nav-powered-by-lendio-pseudo-color: var(--app-nav-powered-by-lendio-pseudo-color);

.lendio-branding {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -32px;
    right: 0;
    height: 1px;
    background-color: $app-nav-powered-by-lendio-pseudo-color;
  }

  .lendio-branding-text {
    font-size: 17px;
    line-height: 26px;
    letter-spacing: 0.27px;
    font-weight: 400;
    margin-right: 16px;
    text-align: center;
    position: relative;
    color: $app-nav-powered-by-lendio-font-color;

    &::after {
      content: '';
      position: absolute;
      right: -8px;
      top: 6px;
      bottom: 6px;
      width: 1px;
      background-color: $app-nav-powered-by-lendio-pseudo-color;
    }
  }

  .lendio-logo-mark {
    height: 20px;
    width: 19px;
  }
}
</style>
